import React from 'react';
import parse from 'html-react-parser';
import classnames from 'classnames';
import styles from './index.module.scss';
import './quill.snow.css';

interface IContent {
    content?: string;
}

const Content: React.FC<IContent> = ({
    content
}): JSX.Element => (
    <div className={classnames(styles.articleContent, 'view ql-editor')}>
        <div className={styles.container}>
            {parse(`${content}`)}
        </div>
    </div>
);

Content.defaultProps = {
    content: '',
};

export default Content;
